var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full h-full"},[_c('keep-alive',[(_vm.layoutLoaded)?_c('router-view',{key:_vm.routerViewKey,ref:"routerView"}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }